import { useMutation } from '@tanstack/react-query';

import { recognitionServices } from '@hero/services';

export const useExpireRecognition = ({ options = {} } = {}) =>
  useMutation(({ code }) => recognitionServices.expireRecognition(code), options);
